module.exports = __webpack_public_path__ + "img/u-p.c1ecf0ec.svg";